
import React from "react";
import { CollectionName } from "../../Atoms/CollectionName";
import { Link, ResponsiveImage } from "@quintype/components";
import { getSlug } from "../../../utils/utils";
import "../../../../components/pages/section.m.css";
import "../OneBigThreeSmallSectionLayout/one-big-three-small-section-layout.m.css";
import "../SeriesPageTabComponent/series-page-tab-component.m.css";

const SeriesPageSimilarItemsComponent = ({
  isAjaxLoading,
  similarSections = [],
  parentOfSimilarSection,
  viewports,
  stateConfig,
  defaultImage
}) => {
  const shouldShowContainer = similarSections.length >= 1;

  return (
    <div styleName="big-img">
      <div styleName="count-sort">
        {(isAjaxLoading || similarSections.length === 0) && (
          <p style={{ padding: "2rem 5rem" }}>
            {isAjaxLoading
              ? "Ladataan..."
              : "Vastaavia ohjelmia ei löytynyt."}
          </p>
        )}
      </div>

      {shouldShowContainer && (
        <div
          styleName="container color-black-1"
          className="collection-only-layout"
          style={{ paddingTop: "20px" }}
        >
          {/*
          {parentOfSimilarSection !== null && parentOfSimilarSection?.slug !=="channel-2"
              && <div styleName="collection-name-upper" className={ viewports ? viewports :""}>
              <CollectionName collection={parentOfSimilarSection} />
              <i className="ri-arrow-right-line"></i>
          </div>}
          */}

          <div styleName="image-grid-series-page" className={viewports ? viewports : ""}>
            {similarSections.map((collectionItem) => {
              const slug = (collectionItem && getSlug(collectionItem, stateConfig)) || "";
              const collectionHeroImgS3Key = collectionItem?.metadata?.["cover-image"]?.["cover-image-s3-key"] || defaultImage;

              if (!collectionHeroImgS3Key) return null;

              return (
                <div id={collectionItem.id} styleName="image-container" key={collectionItem.id} style={{ marginBottom: "20px" }}>
                  <Link href={slug}>
                    <div styleName="responsive-img">
                      <ResponsiveImage
                        aspectRatio={[1, 1]}
                        defaultWidth={480}
                        widths={[250, 480, 640]}
                        slug={collectionHeroImgS3Key}
                        alt={collectionHeroImgS3Key}
                      />
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(SeriesPageSimilarItemsComponent);
